<template>
  <div>
    <div class="op" style="margin-top:10px">
      <authCode v-on:childByValue="childByValue" :msg="msg"></authCode>
      <div class="add">
        <el-select size="mini" clearable v-model="cblx" placeholder="补贴类型">
          <el-option v-for="item6 in cblxList" :key="item6.value" :label="item6.label" :value="item6.value">
          </el-option>
        </el-select>
      </div>
      <el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search"
        @click="serch">搜索</el-button>

      <kt-button icon="fa fa-plus" size="mini" label="新增" perms="time:menu:add" type="success" @click="add" />
    </div>
    <div class="tab">
      <el-table :data="tableData" style="width: 100%" stripe>
        <el-table-column prop="province" label="省" width="180">
        </el-table-column>
        <el-table-column prop="city" label="市" width="100">
        </el-table-column>
        <el-table-column prop="county" width="110" label="县">
        </el-table-column>
        <el-table-column prop="quarry_rule" width="180" label="时间范围">
        </el-table-column>
        <el-table-column prop="verify_type" label="补贴类型">
        </el-table-column>
        <el-table-column prop="match_state" label="截止日期">
        </el-table-column>
        <el-table-column prop="start_time" label="开始时间">
        </el-table-column>
        <el-table-column prop="end_time" label="结束时间">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="change(scope.$index, scope.row)">修改
            </el-button>

          </template>
        </el-table-column>
      </el-table>
      <div class="rrr">
        <el-pagination class="pone" :page-size='10' layout="total, prev, pager, next, jumper" :total="totals"
          :current-page.sync="Page" @current-change="current_change">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="infoMsg">
      <el-form>
        <el-form-item label="补贴类型" :label-width="formLabelWidth">
          <el-select size="mini" :disabled="dis" v-model="cblx" placeholder="请选择">
            <el-option v-for="item in cblxList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围" :label-width="formLabelWidth">
          <el-select size="mini" @change="seletTime" v-model="timeArea" placeholder="请选择">
            <el-option v-for="item in timeAreaList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="isAdd" label="地区" :label-width="formLabelWidth">
          <authCode v-on:childByValue="childByValue2" :msg="msg"></authCode>
        </el-form-item>
        <el-form-item v-show="!isAdd" label="地区" :label-width="formLabelWidth">
          <el-input v-model="addss" style="width:193px" disabled size="mini"></el-input>
        </el-form-item>
        <el-form-item v-show="isTimeShow" label="选择时间" :label-width="formLabelWidth">
          <el-date-picker v-model="time" size='mini' type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <!-- 时间段 -->
        <div class="timequan" v-show="isTimeQuanShow">
          <div class="item-time">
            <el-form-item label="选择时间" :label-width="formLabelWidth">
              <el-date-picker v-model="timeQuan" size='mini' value-format="MM-dd" type="daterange" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <i class="el-icon-circle-plus-outline item_i" @click="addQuan"></i>
          </div>
          <div class="k-9uexn2">
            <div class="k-8dpggf" v-for="(item, index) in timeQuanList" :key="index">{{ `${item[0]}~${item[1]}` }}
              <i @click="delQuan(index)" class="k-8dpggf-del el-icon-close"></i>
            </div>
          </div>
        </div>
        <el-form-item v-show="isCutShow" label="截止日期" :label-width="formLabelWidth">
          <el-select size="mini" v-model="matime">
            <el-option v-for="item in mouList" :key="item.value" :label="item.label" :value="item.value">

            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="infoMsg = false; time = ''; timeArea = ''; cblx = ''; verify_type = ''">取 消</el-button>
        <el-button type="primary" @click="addConfim">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import authCode from "../Core/authCode";
import { getType } from "../../utils/typeAuth";
import { formatDate } from "../../utils/datetimeYMR";
import KtButton from "@/views/Core/KtButton";
import isInQuan from "@/utils/isInQuan";
export default {
  components: {
    authCode,
    KtButton
  },
  data() {
    return {
      mouList: [],
      matime: "",
      isCutShow: false,
      addss: "",
      dis: false,
      isAdd: true,
      msg: 0,
      title: "",
      flag: "",
      totals: 0,
      Page: 1,
      tableData: [],
      isTimeShow: false,
      townList2: [],
      isTimeQuanShow: false,
      timeQuan: "",
      timeQuanList: [],
      time: "",
      formLabelWidth: "120px",
      infoMsg: false,
      cblx: "",
      cblxList: [],
      verify_type: "",
      stateList: [],
      townList: [],
      timeArea: "",
      timeAreaList: [
        {
          label: "禁止认证",
          value: "-1"
        },
        {
          label: "无限制",
          value: "0"
        },
        {
          label: "按时间",
          value: "1"
        },
        {
          label: "按月",
          value: "2"
        },
        {
          label: "按周",
          value: "3"
        },
        {
          label: "截止日期",
          value: "4"
        },
        {
          label: "每天",
          value: "5"
        }
      ],
      fom: ""
    };
  },
  methods: {
    // 删除
    delQuan(index) {
      this.timeQuanList.splice(index, 1);
    },
    addQuan() {
      if (!this.timeQuan) return;
      if (!isInQuan(this.timeQuan, this.timeQuanList)) {
        this.$message({
          type: "warning",
          message: "时间段不能重复"
        });
        return;
      }
      this.timeQuanList.push(this.timeQuan);
      this.timeQuan = [];
      //
      console.log(this.timeQuanList);
    },
    current_change(s) {
      this.Page = s;
      this.look(this.Page);
    },
    seletTime() {
      if (this.timeArea == 1) {
        this.isTimeShow = true;
        this.isCutShow = false;
        this.matime = "";
      } else if (this.timeArea == 4) {
        this.isCutShow = true;
        this.isTimeShow = false;
        this.time = "";
      } else if (this.timeArea == 6) {
        this.isCutShow = false;
        this.isTimeShow = false;
        this.isTimeQuanShow = true;
      } else {
        this.isTimeShow = false;
        this.isCutShow = false;
        this.time = "";
        this.matime = "";
      }
    },
    childByValue(val) {
      this.townList = val;
      console.log(this.townList);
    },
    childByValue2(val) {
      this.townList2 = val;
      console.log(this.townList2);
    },

    serch() {
      this.look(this.Page);
    },
    look(s) {
      let data = {
        pageNum: s,
        pageSize: 10,
        province: this.townList[0] ? this.townList[0].split(",")[1] : "",
        city: this.townList[1] ? this.townList[1].split(",")[1] : "",
        county: this.townList[2] ? this.townList[2].split(",")[1] : "",
        verify_type: this.cblx
      };
      this.$api.getlist
        .authLook(data)
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.totals = res.data.page.total_count;
          } else {
            this.$message({
              type: "warning",
              message: res.message
            });
            this.tableData = [];
          }
        })
        .catch(res => {});
    },
    //修改
    change(s, d) {
      //this.msg++
      this.time = "";
      this.timeArea = d.birthday;
      this.isAdd = false;
      this.addss = d.province + d.city + d.county;
      this.dis = true;
      if (this.timeArea == 1) {
        this.isTimeShow = true;
      }

      this.infoMsg = true;
      this.flag = 2;
      this.fom = d;
      this.title = "修改时间段";
      this.verify_type = JSON.parse(d.bak1);
    },
    add() {
      this.dis = false;
      this.isAdd = true;
      (this.time = ""),
        (this.timeArea = ""),
        // this.msg++
        (this.infoMsg = true);
      this.title = "新增时间段";
      this.flag = 1;
      setTimeout(() => {
        console.log(111, this.townList);
      }, 1000);
    },
    addConfim() {
      if (this.flag == 1) {
        let data = {
          province: this.townList2[0] ? this.townList2[0].split(",")[1] : "",
          city: this.townList2[1] ? this.townList2[1].split(",")[1] : "",
          county: this.townList2[2] ? this.townList2[2].split(",")[1] : "",
          verify_type: this.cblx,
          start_time: this.time ? formatDate(this.time[0]) : "",
          end_time: this.time ? formatDate(this.time[1]) : "",
          quarry_rule: this.timeArea,
          personName: sessionStorage.getItem("user"),
          match_state: this.matime,
          timegroup: this.timeQuanList.join("&").replace(/,/g, "~")
        };
        this.$api.getlist
          .authAdd(data)
          .then(res => {
            if (res.code == 200) {
              this.infoMsg = false;
              // this.townList=""
              //this.msg++
              this.serch();
              this.$message({
                type: "success",
                message: "新增成功"
              });
            } else {
              this.$message({
                type: "warning",
                message: res.message
              });
            }
          })
          .catch(res => {});
      } else if (this.flag == 2) {
        let data = {
          province: this.fom.province,
          city: this.fom.city,
          county: this.fom.county,
          verify_type: this.verify_type,
          start_time: this.time ? formatDate(this.time[0]) : "",
          end_time: this.time ? formatDate(this.time[1]) : "",
          quarry_rule: this.timeArea,
          personName: sessionStorage.getItem("user"),
          id: this.fom.id,
          match_state: this.matime
        };
        this.$api.getlist
          .authUpdate(data)
          .then(res => {
            if (res.code == 200) {
              this.infoMsg = false;
              this.serch();
              this.$message({
                type: "success",
                message: "修改成功"
              });
            } else {
              this.$message({
                type: "warning",
                message: res.message
              });
            }
          })
          .catch(res => {});
      }
    }
  },
  created() {
    for (var i = 1; i <= 28; i++) {
      this.mouList.push({
        value: i,
        label: i + "日"
      });
    }
    console.log(this.mouList);
    let arr;
    if (sessionStorage.getItem("typeControll") == "null") {
      arr = JSON.parse(sessionStorage.getItem("codes"));
    } else {
      arr = JSON.parse(sessionStorage.getItem("typeControll"));
      arr.unshift("");
    }

    for (let i in arr) {
      this.cblxList.push({
        label: getType(arr[i]),
        value: arr[i]
      });
    }
    this.cblx = arr[0];
    console.log(this.cblx);
  }
};
</script>
<style>
.op {
  display: flex;
  align-items: center;
}

.add {
  margin-left: 10px;
}

.el-form-item__content {
  text-align: left;
}

.item-time {
  display: flex;
  align-items: center;
}

.item_i {
  margin-bottom: 22px;
  font-size: 20px;
  margin-left: 4px;
}

.k-9uexn2 {
  display: flex;
  flex-wrap: wrap;
}

.k-8dpggf {
  position: relative;
  padding: 4px;
  border: 1px solid lightgray;
  border-radius: 4px;
  margin-left: 30px;
  margin-bottom: 10px;
}

.k-8dpggf-del {
  position: absolute;
  right: -15px;

  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Myvue/authTime.vue